"use client";
import { usePathname } from "next/navigation";
import { useCallback, useEffect, useRef } from "react";
// import Router from "next/router";

// App router
export function useBackForward({ onBack, onForward } = {}) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const getIdx = () =>
      history.state && typeof history.state.idx === "number"
        ? history.state.idx
        : 0;

    let prev = getIdx();

    const onPop = (e) => {
      const next = e.state && typeof e.state.idx === "number" ? e.state.idx : 0;
      if (next < prev) onBack?.();
      else if (next > prev) onForward?.();
      prev = next;
    };

    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [onBack, onForward]);
}

export function useNavigationDirection({ onBack, onForward } = {}) {
  const pathname = usePathname();
  const historyStack = useRef([pathname]);
  const currentIndex = useRef(0);

  useEffect(() => {
    const handlePopState = () => {
      const currentPath = window.location.pathname;
      const lastIndex = historyStack.current.lastIndexOf(currentPath);

      if (lastIndex !== -1 && lastIndex < currentIndex.current) {
        onForward?.();
        currentIndex.current = lastIndex;
      } else {
        onBack?.();
        currentIndex.current++;
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  // Track new navigations
  useEffect(() => {
    historyStack.current.push(pathname);
    currentIndex.current = historyStack.current.length - 1;
  }, [pathname]);
}

// export function usePreventBack(shouldPrevent = true) {
//   const handlePopState = useCallback(() => {
//     if (shouldPrevent) {
//       // Just push the current state back without any confirmation
//       // This prevents back navigation silently
//       window.history.pushState(null, "", window.location.href);
//     }
//   }, [shouldPrevent]);

//   useEffect(() => {
//     if (shouldPrevent) {
//       // Add an entry to history
//       window.history.pushState(null, "", window.location.href);
//       window.addEventListener("popstate", handlePopState);
//     }

//     return () => {
//       window.removeEventListener("popstate", handlePopState);
//     };
//   }, [shouldPrevent, handlePopState]);
// }

// Pages router
// export function useBackForward({ onBack, onForward } = {}) {
//   useEffect(() => {
//     const getIdx = () =>
//       history.state && typeof history.state.idx === "number"
//         ? history.state.idx
//         : 0;

//     let prev = getIdx();

//     Router.beforePopState(() => {
//       const next = getIdx();
//       if (next < prev) onBack?.();
//       else if (next > prev) onForward?.();
//       prev = next;
//       return true; // allow the navigation
//     });

//     return () => Router.beforePopState(() => true);
//   }, [onBack, onForward]);
// }
